var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading !== 0,
              expression: "loading !== 0"
            }
          ],
          staticClass: "portlet light"
        },
        [
          _c("h2", [_vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")]),
          _vm._v(" "),
          _c("ring-loader")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading === 0,
              expression: "loading === 0"
            }
          ],
          staticClass: "portlet light bordered"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row", staticStyle: { "margin-bottom": "20px" } },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "col-md-1 control-label" }, [
                  _vm._v("Na datę")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-2" },
                  [
                    _c("date-picker", {
                      attrs: { time: false },
                      model: {
                        value: _vm.dateFrom,
                        callback: function($$v) {
                          _vm.dateFrom = $$v
                        },
                        expression: "dateFrom"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3" },
                  [
                    _c("singleselect", {
                      attrs: {
                        title: "Markę",
                        name: "brand",
                        options: _vm.brands,
                        label: "name"
                      },
                      model: {
                        value: _vm.brand,
                        callback: function($$v) {
                          _vm.brand = $$v
                        },
                        expression: "brand"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: {
                        type: "submit",
                        disabled: _vm.disabledButton < 6
                      },
                      on: { click: _vm.generate }
                    },
                    [_vm._v("Generuj")]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "portlet-body form" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadingDrivers != 0,
                          expression: "loadingDrivers != 0"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-12" },
                        [_c("ring-loader")],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadingDrivers == 0,
                          expression: "loadingDrivers == 0"
                        }
                      ]
                    },
                    [
                      _c("div", { staticClass: "dashboard-stat2 bordered" }, [
                        _c("div", { staticClass: "display" }, [
                          _c("div", { staticClass: "number" }, [
                            _c("h3", { staticClass: "font-green-sharp" }, [
                              _c(
                                "span",
                                { attrs: { "data-counter": "counterup" } },
                                [_vm._v(_vm._s(_vm.driversReportCount))]
                              )
                            ]),
                            _vm._v(" "),
                            _vm._m(1)
                          ])
                        ])
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadingStickers != 0,
                          expression: "loadingStickers != 0"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-12" },
                        [_c("ring-loader")],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadingStickers == 0,
                          expression: "loadingStickers == 0"
                        }
                      ]
                    },
                    [
                      _c("div", { staticClass: "dashboard-stat2 bordered" }, [
                        _c(
                          "div",
                          {
                            staticClass: "display",
                            staticStyle: { "margin-bottom": "0" }
                          },
                          [
                            _c("div", { staticClass: "number" }, [
                              _c("h3", { staticClass: "font-green-sharp" }, [
                                _c(
                                  "span",
                                  { attrs: { "data-counter": "counterup" } },
                                  [_vm._v(_vm._s(_vm.stickersCount))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("small", [_vm._v("naklejki na torby")]),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.stickerReportPartOne
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                część 1\n                                            "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("small", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: _vm.stickerReportPartTwo
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                część 2\n                                            "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadingActive != 0,
                          expression: "loadingActive != 0"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-sm-12" },
                        [_c("ring-loader")],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadingActive == 0,
                          expression: "loadingActive == 0"
                        }
                      ]
                    },
                    [
                      _c("div", { staticClass: "dashboard-stat2 bordered" }, [
                        _c("div", { staticClass: "display" }, [
                          _c("div", { staticClass: "number" }, [
                            _c("h3", { staticClass: "font-green-sharp" }, [
                              _c(
                                "span",
                                { attrs: { "data-counter": "counterup" } },
                                [_vm._v(_vm._s(_vm.activeCount))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("small", [_vm._v("liczba zamówień aktywnych")])
                          ])
                        ])
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadingWithoutCheckboxActive != 0,
                      expression: "loadingWithoutCheckboxActive != 0"
                    }
                  ],
                  staticClass: "row"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-12" },
                    [_c("ring-loader")],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadingWithoutCheckboxActive == 0,
                      expression: "loadingWithoutCheckboxActive == 0"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12" },
                    [
                      _c("div", { staticClass: "dashboard-stat2 bordered" }, [
                        _c("div", { staticClass: "display" }, [
                          _c("div", { staticClass: "number" }, [
                            _c("h3", { staticClass: "font-green-sharp" }, [
                              _c(
                                "span",
                                { attrs: { "data-counter": "counterup" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.ordersWithoutCheckboxActiveCount)
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(
                                'numery zamówień z niezaznaczonym checkboxem "aktywne"'
                              )
                            ])
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12" },
                    _vm._l(_vm.ordersWithoutCheckboxActive, function(
                      orderId,
                      index
                    ) {
                      return _c(
                        "a",
                        {
                          key: index,
                          attrs: {
                            target: "_blank",
                            href: "/order/update/" + orderId
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(orderId) +
                              ",\n                            "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadingContactWithUs != 0,
                      expression: "loadingContactWithUs != 0"
                    }
                  ],
                  staticClass: "row"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-12" },
                    [_c("ring-loader")],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadingContactWithUs == 0,
                      expression: "loadingContactWithUs == 0"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12" },
                    [
                      _c("div", { staticClass: "dashboard-stat2 bordered" }, [
                        _c("div", { staticClass: "display" }, [
                          _c("div", { staticClass: "number" }, [
                            _c("h3", { staticClass: "font-green-sharp" }, [
                              _c(
                                "span",
                                { attrs: { "data-counter": "counterup" } },
                                [_vm._v(_vm._s(_vm.ordersContactWithUsCount))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(
                                'liczba opłaconych zamówień z zaznaczonym checkboxem "skontaktuj się z nami"'
                              )
                            ])
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12" },
                    _vm._l(_vm.ordersContactWithUs, function(orderId, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          attrs: {
                            target: "_blank",
                            href: "/order/update/" + orderId
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(orderId) +
                              ",\n                            "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadingWrongServing != 0,
                      expression: "loadingWrongServing != 0"
                    }
                  ],
                  staticClass: "row"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-12" },
                    [_c("ring-loader")],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loadingWrongServing == 0,
                      expression: "loadingWrongServing == 0"
                    }
                  ]
                },
                [
                  _c("h1", [_vm._v("Zgodność menu z zamówionymi posiłkami")]),
                  _vm._v(" "),
                  _c("table", { staticClass: "table" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.wrongServing, function(row, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            row.selected_meal_id
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "/meal/show/" + row.selected_meal_id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(row.meal_name) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              : _c("span", [_vm._v(_vm._s(row.meal_name))])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              { attrs: { href: "/bag/update/" + row.bag_id } },
                              [_vm._v(_vm._s(row.bag_item_id))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              { attrs: { href: "/bag/update/" + row.bag_id } },
                              [_vm._v(_vm._s(row.bag_id))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: { href: "/order/update/" + row.order_id }
                              },
                              [_vm._v(_vm._s(row.order_id))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            row.selected_meal_id
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "/meal/show/" + row.selected_meal_id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(row.selected_meal_id) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(row.selected_meal_id))
                                ])
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c("i", { staticClass: "icon-equalizer font-red-sunglo" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "caption-subject font-red-sunglo bold uppercase" },
          [_vm._v("raport kontrolny")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _c(
        "a",
        { attrs: { target: "_blank", href: "/drivers_report/drivers_report" } },
        [_vm._v("raport dla kierowców")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Posiłek")]),
        _vm._v(" "),
        _c("th", [_vm._v("Id elementu torby")]),
        _vm._v(" "),
        _c("th", [_vm._v("Id torby")]),
        _vm._v(" "),
        _c("th", [_vm._v("Id zamówienia")]),
        _vm._v(" "),
        _c("th", [_vm._v("Id posiłku")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05faf0b8", { render: render, staticRenderFns: staticRenderFns })
  }
}